import React from 'react';
import { IconButton } from '@nokia-csf-uxr/ccfk';

interface IconButtonProps {
  icon: React.ComponentType<any>;  // Accepts a React component as prop
  disabled: boolean;
  onclick: () => void;
  iconColor: string;
}

const IconButtons: React.FC<IconButtonProps> = (
  { 
    icon: Icon,
    iconColor,
    disabled,
    onclick 
  }) => {
  return (
    <IconButton
      aria-label="settings"
      disabled={disabled}
      onClick={onclick}
      onKeyDown={(event) => {
        event.persist();
      }}
      // onKeyPress={(event) => {
      //   event.persist();
      // }}
      onKeyUp={(event) => {
        event.persist();
      }}
      onFocus={(event) => {
        event.persist();
      }}
      onBlur={(event) => {
        event.persist();
      }}
    >
    {Icon && <Icon color={iconColor} />}
    </IconButton>
  );
};

export default IconButtons;
